import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import { Call } from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    schedulesList: null,
    openForm: false,
    activeSchedule: null,
};

export const AttendanceRounds = createSlice({
    name: "AttendanceRounds",
    initialState,
    reducers: {
        setSchedulesList: (state, action) => {
            state.schedulesList = action.payload;
        },
        clearSchedulesList: (state) => {
            state.schedulesList = initialState.schedulesList;
        },

        setOpenForm: (state, action) => {
            state.openForm = action.payload;
        },

        setActiveSchedule: (state, action) => {
            state.activeSchedule = action.payload;
        },
        clearActiveSchedule: (state) => {
            state.activeSchedule = initialState.activeSchedule;
        },
    },
});

export const {
    setSchedulesList,
    clearSchedulesList,
    setOpenForm,
    setActiveSchedule,
    clearActiveSchedule,
} = AttendanceRounds.actions;

export default AttendanceRounds.reducer;

//* Actions
export const startGetAttendanceRounds = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `teachers/attendance_rounds/show`,
            "POST",
            values
        );

        if (resp.success) {
            dispatch(setSchedulesList(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreateAttendanceRounds = (
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/attendance-rounds/create`,
            "POST",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: "Rondín registrado correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};
